import { render, staticRenderFns } from "./patients-page.vue?vue&type=template&id=dfbd173c"
import script from "./patients-page.vue?vue&type=script&lang=js"
export * from "./patients-page.vue?vue&type=script&lang=js"
import style0 from "./patients-page.vue?vue&type=style&index=0&id=dfbd173c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports